<template>
  <div>
    <template v-if="hasInvoice">
      <InvoiceSettings
        :scope="scope"
        :invoice="invoice"
        @reinit="setInvoiceData"
        class="print-hidden"
      />

      <div class="invoice">
        <div class="invoice--block block mt-10 pagebreak">
          <InvoiceHeader :invoice="invoice" />
          <InvoiceProductList :products="invoice.OrderPackages" />
          <div class="invoice--payment mt-50 pagebreak">
            <div class="row">
              <div class="col-md-6">
                <InvoicePaymentMethod :instructions="invoice_instructions" />
              </div>
              <div class="col-md-6 d-flex justify-content-end">
                <table class="invoice--table invoice--payment-summary">
                  <tbody class="invoice--table-body">
                    <tr class="invoice--table-row invoice--table-header">
                      <td class="font-size-20 font-weight-bold">Total Due</td>
                      <td></td>
                    </tr>
                    <tr class="payment-amount">
                      <td>Amount</td>
                      <td class="text-right">
                        {{ convertToMoney(invoice.totalAmount / 1.12) }}
                      </td>
                    </tr>
                    <tr class="invoice--table-row payment-total">
                      <td>Input Vat</td>
                      <td class="text-right">
                        {{
                          convertToMoney(
                            invoice.totalAmount - invoice.totalAmount / 1.12
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-20 font-weight-bold">Total</td>
                      <td class="font-size-20 font-weight-bold text-right">
                        {{ convertToMoney(invoice.totalAmount) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="container invoice" v-else>
      <div class="invoice--block block">
        <Spinner :theme="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceProductList from "./InvoiceProductList";
import InvoiceSettings from "./InvoiceSettings";
import InvoicePaymentMethod from "./InvoicePaymentMethod";
import moment from "@/helpers/moment";
import Spinner from "@/components/Spinner";
import _ from "lodash";

export default {
  components: {
    InvoiceHeader,
    InvoiceProductList,
    InvoiceSettings,
    InvoicePaymentMethod,
    Spinner
  },
  props: {
    invoiceId: {
      type: [String, Number],
      default: null
    },
    userId: {
      type: [String, Number],
      default: null
    },
    scope: {
      type: [String],
      default: null
    }
  },
  data() {
    return {
      invoice: null,
      text: "Loading...",
      invoice_instructions: ""
    };
  },
  computed: {
    hasInvoice() {
      if (!this.invoice) {
        this.setInvoiceData();
        return false;
      } else {
        return true;
      }
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  async created() {
    this.setInvoiceData();
    let searchKey = "invoice.main";
    await this.$store.dispatch("fetchOptions", searchKey);
    let options = this.$store.state.concierge.optionsList.data;
    this.invoice_instructions = _.filter(options, val => {
      return val.label == "Payment Instructions";
    })[0];
  },
  methods: {
    setInvoiceData() {
      this.getInvoiceData().then(response => {
        const invoice = response.data;
        if (invoice) {
          if (this.userId) {
            if (invoice.userId === this.userId) {
              this.invoice = invoice;
            } else {
              this.text = "Invalid Invoice";
            }
          } else {
            this.invoice = invoice;
          }
        } else {
          this.text = "Invalid Invoice";
        }
      });
    },
    getInvoiceData() {
      const { invoiceId } = this;
      return new Promise((resolve, reject) => {
        axios
          .get(`/orders/${invoiceId}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => reject(error));
      });
    },

    convertToMoney(amount) {
      return (
        "Php " +
        amount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      );
    },
    formatDate(date, format = "MM/DD/YYYY") {
      return moment(date).format(format);
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice {
  .font-size-20 {
    font-size: 20px;
  }
  .colorGray {
    color: #4c4c4c;
  }
  &--block {
    padding: 50px 80px 50px 80px;
  }
  &--table {
    width: 100%;
    th,
    td {
      font-family: "Arial";
    }
    &-row {
      border-bottom: 1px solid #cccccc;
      &.invoice--table-header {
        border-bottom: 4px solid #cccccc;
        td {
          vertical-align: top;
        }
      }
      td {
        font-size: 16px;
      }
      span {
        font-family: "Arial";
      }
    }
    &-thead {
      padding-bottom: 20px;
      border-bottom: 5px solid #cccccc;
      th {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  &--payment {
    &-method {
      &--details {
        margin-top: 20px;
        padding: 15px;
        li {
          padding: 5px;
          ul {
            padding: 10px 25px;
          }
        }
      }
    }
    &-summary {
      max-width: 90%;
      .payment-amount {
        border-bottom: none;
        td {
          font-size: 16px;
          padding-top: 10px;
        }
      }
      .payment-total {
        td {
          padding-bottom: 10px;
        }
      }
      .font-weight-bold {
        color: #232323;
      }
    }
  }
}

@media print {
  * {
    /* force reset everything to its default overflow value when printing to enable page breaks */
    overflow: visible !important;
  }

  .print-hidden {
    display: none;
  }

  .invoice--payment {
    padding-top: 30px;
  }
}

@media print {
  .block {
    background-color: transparent;
    margin: 0 !important;
    padding: 0;
  }
}
</style>
